export const isDevelopment = () => process.env.VUE_APP_ENV_MODE !== 'production'
